import { InteractCheckIcon, InteractI18nActiveIcon, InteractI18nIcon } from '@/client/assets';
import { Button } from '@/client/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/client/components/ui/dropdown-menu';
import useLocale from '@/client/hooks/use-locale';
import { cn } from '@/client/utils';
import { useState } from 'react';
import useMedia from 'react-use/lib/useMedia';

export const SwitchLocale = ({
  variant = 'icon',
  showOnMobile = false,
  className,
}: {
  variant?: 'icon' | 'text';
  // Default hides below md (mobile language switching normally lives in the
  // NavMobile "More" sheet); the market header opts in to a mobile trigger.
  showOnMobile?: boolean;
  className?: string;
}) => {
  const [open, setOpen] = useState(false);
  const { locale, locales, switchLocale } = useLocale();
  const isDesktop = useMedia('(min-width: 768px)');
  const currentLocale = locales.find(item => item.lang === locale);

  if (!isDesktop && !showOnMobile) return null;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        {variant === 'text' ? (
          <button
            className={cn(
              'flex items-center gap-1.5 text-xs text-foreground/60 hover:text-foreground transition-colors',
              open && 'text-foreground'
            )}
          >
            <InteractI18nIcon className="fill-current size-4" />
            <span>{currentLocale?.name || 'English'}</span>
          </button>
        ) : (
          <Button
            variant="outline"
            size="icon"
            className={cn(
              'p-2 border border-foreground/4 shadow-none',
              open ? 'bg-foreground/5' : 'bg-transparent hover:bg-foreground/5',
              className
            )}
          >
            {open ? (
              <InteractI18nActiveIcon className="fill-current size-4" />
            ) : (
              <InteractI18nIcon className="fill-current size-4" />
            )}
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent className="border-foreground/4 bg-card" side={variant === 'text' ? 'top' : 'bottom'}>
        {locales.map(item => (
          <DropdownMenuItem
            key={item.lang}
            onClick={() => switchLocale(item.lang)}
            className={cn(
              'flex items-center justify-between text-sm text-foreground/70 cursor-pointer',
              item.lang === locale && 'text-foreground bg-foreground/5'
            )}
          >
            {item.name}
            {item.lang === locale && <InteractCheckIcon className="size-4 fill-foreground" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
